<template>
    <div class="modal">
        <div class="modal__inner">
            <div v-on-clickaway="close">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
    mixins: [clickaway],

    created() {
        document.addEventListener('keydown', this.handleEscape)
        document.body.classList.add('overflow-hidden')
    },

    destroyed() {
        document.removeEventListener('keydown', this.handleEscape)
        document.body.classList.remove('overflow-hidden')
    },

    methods: {
        handleEscape(e) {
            e.stopPropagation()

            if (e.keyCode == 27) {
                this.close()
            }
        },

        close() {
            this.$emit('modal-close')
        },
    },
}
</script>

<style lang="scss">
.modal {
    @apply .select-none .fixed .pin .overflow-x-hidden .overflow-y-auto;

    background: rgba(0,0,0,0.4);

    z-index: 500;

    &__inner {
        @apply .relative .mx-auto .flex .justify-center .z-20;

        margin-top: 8%;
    }

    &__box {
        @apply .bg-white .rounded-lg .shadow-lg .overflow-hidden .w-full;

        min-width: 480px;
        max-width: 480px;

        &--large {
            max-width: 600px;
            min-width: 600px;
        }

        &--xlarge {
            max-width: 800px;
            min-width: 800px;
        }
    }

    &__ttl {
        @apply .bg-grey-lighter .pb-6 .pt-8 .px-8;
    }

    &__footer {
        @apply .bg-grey-lightest .p-6 .flex;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue